var React = require('react');

function IconTwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.76 2.21a6.5 6.5 0 0 1-1.87.512A3.26 3.26 0 0 0 16.322.921c-.629.373-1.326.644-2.068.79A3.25 3.25 0 0 0 11.878.683 3.26 3.26 0 0 0 8.706 4.68c-2.705-.136-5.104-1.432-6.71-3.401a3.26 3.26 0 0 0 1.007 4.347 3.24 3.24 0 0 1-1.474-.407A3.26 3.26 0 0 0 4.14 8.452c-.458.124-.96.153-1.471.056a3.26 3.26 0 0 0 3.042 2.261c-1.369 1.073-3.093 1.552-4.82 1.349 1.441.924 3.153 1.463 4.991 1.463 6.045 0 9.46-5.105 9.254-9.684A6.63 6.63 0 0 0 16.76 2.21z"}));
}

IconTwitter.defaultProps = {"width":"17","height":"14","fill":"#fff"};

module.exports = IconTwitter;

IconTwitter.default = IconTwitter;
